import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ServicesGrid from "./components/ServicesGrid";
import AnimatedSection from "../../components/base/AnimatedSection";

export default function ServiciosPage() {
  return (
    <div className="min-h-screen flex flex-col font-body">
      <Navbar />
      <main className="flex-1">
        {/* Page header */}
        <section className="bg-white pt-32 pb-16">
          <div className="max-w-7xl mx-auto px-6">
            <AnimatedSection>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-8 h-0.5" style={{ backgroundColor: "#E8150C" }}></div>
                <span className="font-body text-brand-red text-sm font-medium tracking-widest uppercase">
                  Lo que hacemos
                </span>
              </div>
              <h1 className="font-heading font-black text-brand-black leading-none"
                style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>
                NUESTROS SERVICIOS
              </h1>
              <p className="font-body text-brand-gray-mid text-base mt-4 max-w-xl leading-relaxed">
                Gestión integral para que el organizador solo se ocupe del deporte. Nos encargamos de todo lo demás.
              </p>
              <div className="w-full h-px mt-10" style={{ backgroundColor: "#F4F4F4" }}></div>
            </AnimatedSection>
          </div>
        </section>

        <ServicesGrid />
      </main>
      <Footer />
    </div>
  );
}